import { render, staticRenderFns } from "./byConcept.vue?vue&type=template&id=0a1de9d8&"
import script from "./byConcept.vue?vue&type=script&lang=js&"
export * from "./byConcept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports